import * as EventsApi from 'api/events';
import * as MySuccessApi from 'api/mySuccess';
import * as ProgramApi from 'api/program';
import Sequences from 'defs/sequences';
import { call, put, select } from 'redux-saga/effects';
import { getIsOnline } from 'store/connection';
import { actionCreators as eventsAC } from 'store/events';
import { getIsMigrosAuthenticated } from 'store/login';
import { actionCreators as mySuccessAC } from 'store/mySuccess';
import { getIsPreviewUser } from 'store/profile';
import { actionCreators as programAC } from 'store/programs';
import { actionCreators as sequenceAC } from 'store/sequences';

export function* loadAsyncEvents() {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return;
	}

	const isMigrosAuthenticated = yield select(getIsMigrosAuthenticated);
	if (!isMigrosAuthenticated) {
		return;
	}

	yield put(programAC.doRequestActiveProgramsLoading(true));
	yield put(sequenceAC.doStartSequence(Sequences.LOAD_MY_SUCCESS_HALL_OF_FAME));
	yield put(mySuccessAC.doRequestMySuccessLoading());
	try {
		const hallOfFame = yield call(MySuccessApi.fetchHallOfFame);
		yield put(eventsAC.doRequestMySuccessSuccess(hallOfFame));

		const activePrograms = yield call(ProgramApi.fetchActivePrograms);
		yield put(programAC.doRequestActiveProgramsSuccess(activePrograms));

		if (activePrograms && activePrograms[0] && activePrograms[0].externalId) {
			const isPreviewUser = yield select(getIsPreviewUser);
			const program = yield call(ProgramApi.fetchProgramPreview, activePrograms[0].externalId, isPreviewUser);

			yield put(eventsAC.doReceivedProgram(program));
		}

		const events = yield call(EventsApi.fetchAsyncEvents);

		if (Array.isArray(events)) {
			yield put(eventsAC.doReceiveAsyncEvents(events));
		}
	} catch (err) {
		yield put(eventsAC.doReceiveAsyncEventsFailure(err));
	}
}
export function* loadCustomOverlays() {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return;
	}

	const isMigrosAuthenticated = yield select(getIsMigrosAuthenticated);
	if (!isMigrosAuthenticated) {
		return;
	}

	try {
		const allCustomOverlays = yield call(EventsApi.fetchCustomOverlays);
		const profileCustomOverlayIds = yield call(EventsApi.fetchProfileCustomOverlays);

		const newCustomOverlays = allCustomOverlays.filter((overlay) => {
			return !profileCustomOverlayIds.some((op) => op === overlay.id);
		});

		yield put(eventsAC.doReceiveCustomOverlays(newCustomOverlays));
	} catch (err) {
		yield put(eventsAC.doReceiveCustomOverlaysFailure(err));
	}
}

export function* saveCustomOverlayShown(action: ReturnType<typeof eventsAC.doSaveCustomOverlayShown>) {
	return yield call(EventsApi.putCustomOverlayShown, { overlayId: action.id });
}
